// extracted by mini-css-extract-plugin
export default {"header":"Header_header__pGrVn","title":"Header_title__nNmWw","blob":"Header_blob__jl6XB","value":"Header_value__2AGWT"};